export enum BenchmarkFields {
    Type = 'type',
    Previous = 'previous',
    Goal = 'goal'
}
